import React from 'react';

export const DocumenetUploadIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        fill="#1974C7"
        fill-opacity="0.1"
      />
      <rect
        x="2"
        y="2"
        width="32"
        height="32"
        rx="16"
        stroke="#1974C7"
        stroke-opacity="0.1"
        strokeWidth="4"
      />
      <path
        d="M19.3332 11.5136V14.2673C19.3332 14.6407 19.3332 14.8274 19.4058 14.97C19.4697 15.0954 19.5717 15.1974 19.6972 15.2613C19.8398 15.334 20.0265 15.334 20.3998 15.334H23.1535M23.3332 16.6595V21.4673C23.3332 22.5874 23.3332 23.1475 23.1152 23.5753C22.9234 23.9516 22.6175 24.2576 22.2412 24.4493C21.8133 24.6673 21.2533 24.6673 20.1332 24.6673H15.8665C14.7464 24.6673 14.1863 24.6673 13.7585 24.4493C13.3822 24.2576 13.0762 23.9516 12.8845 23.5753C12.6665 23.1475 12.6665 22.5874 12.6665 21.4673V14.534C12.6665 13.4139 12.6665 12.8538 12.8845 12.426C13.0762 12.0497 13.3822 11.7437 13.7585 11.552C14.1863 11.334 14.7464 11.334 15.8665 11.334H18.0077C18.4969 11.334 18.7415 11.334 18.9716 11.3892C19.1757 11.4382 19.3708 11.519 19.5497 11.6287C19.7516 11.7524 19.9245 11.9253 20.2704 12.2712L22.3959 14.3967C22.7418 14.7426 22.9148 14.9156 23.0385 15.1174C23.1481 15.2964 23.2289 15.4914 23.2779 15.6955C23.3332 15.9257 23.3332 16.1703 23.3332 16.6595Z"
        stroke="#1974C7"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
